/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Provision_AmountInputs */

const cs_deals_provision_amount = /** @type {(inputs: Deals_Provision_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize (částka)`)
};

const en_deals_provision_amount = /** @type {(inputs: Deals_Provision_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission (amount)`)
};

/**
* | output |
* | --- |
* | "Commission (amount)" |
*
* @param {Deals_Provision_AmountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_provision_amount = /** @type {((inputs?: Deals_Provision_AmountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Provision_AmountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_provision_amount(inputs)
	return cs_deals_provision_amount(inputs)
});